import { Component } from '@theme/component';

/**
 * Pack-size picker for a product card: a radio per variant with its price beside it, and an
 * add-to-cart button below. Selecting a radio rewrites the hidden variant input of the card's
 * own product form, so the existing `product-form-component` performs the add - which also
 * means the cart drawer opens on add exactly as it does everywhere else in the theme.
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} variantId - The product form's hidden variant input.
 * @property {HTMLInputElement[]} [option] - The radio inputs, one per variant.
 * @property {HTMLButtonElement} [submit] - The add-to-cart button.
 *
 * @extends {Component<Refs>}
 */
class CasscadoPackPicker extends Component {
  requiredRefs = ['variantId'];

  /**
   * Points the form at the chosen variant. Bound through `on:change="/selectPack"`, which
   * carries no data segment, so the event is the only argument.
   * @param {Event} event - The change event from the radio.
   */
  selectPack(event) {
    const input = event?.target;

    if (!(input instanceof HTMLInputElement) || !input.checked) return;

    const { variantId, available, price } = input.dataset;

    if (variantId) this.refs.variantId.value = variantId;

    // An unavailable variant must not be addable, and the form must not post a stale id.
    const canAdd = available === 'true';
    this.refs.variantId.disabled = !canAdd;

    const { submit } = this.refs;
    if (submit) {
      submit.disabled = !canAdd;
      submit.setAttribute('aria-disabled', String(!canAdd));
    }

    if (price) this.dataset.selectedPrice = price;
  }
}

if (!customElements.get('casscado-pack-picker')) {
  customElements.define('casscado-pack-picker', CasscadoPackPicker);
}
